import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonToggle, InputBoxSingle } from '@peacecover/component';

interface SettingThirdPersonaPopupProps {
  onClose: () => void;
}

const SettingThirdPersonaPopup = ({ onClose }: SettingThirdPersonaPopupProps) => {
  const { t } = useTranslation();
  const [thirdPersonaName, setThirdPersonaName] = useState('');
  const [isAlwaysUseThisName, setIsAlwaysUseThisName] = useState(true);
  return (
    // biome-ignore lint/a11y/useSemanticElements: 내부에 <button>들이 있어 최상위 컨테이너를 <button>으로 바꾸면 중첩 버튼이 되어 HTML/a11y가 더 악화됩니다.
    <div
      role="button"
      tabIndex={0}
      onClick={onClose}
      className="fixed top-0 left-0 w-full h-full bg-black/50 z-[1000] flex items-center justify-center"
    >
      <div className="bg-backgroundElevated-dark rounded-[24px] px-[14px] pt-[32px] pb-[16px] w-[311px] flex flex-col gap-[16px] items-center">
        <div className="flex flex-col gap-[14px] items-center">
          <p className="text-[17px] font-bold leading-[20px] text-main-dark-1">
            이 씬에서는 새로운 등장인물이 있어요
          </p>
          <p className="text-[13px] leading-[16px] font-medium text-main-dark-2">
            새로 등장할 인물의 이름을 입력해주세요
          </p>
        </div>
        <div className="setting-third-persona-input-wrapper w-full">
          <InputBoxSingle
            value={thirdPersonaName}
            onChange={(e) => setThirdPersonaName(e.target.value)}
            placeholder={t('SceneSetting.enterUserInfo.placeholder') as string}
            className="w-full bg-transparent text-[17px] font-semibold !text-main-dark-2 placeholder:text-placeholder-dark"
            showIcon={thirdPersonaName.trim().length > 0}
            onClear={() => setThirdPersonaName('')}
          />
        </div>
        <button
          type="button"
          onClick={() => setIsAlwaysUseThisName(!isAlwaysUseThisName)}
          className="flex items-center justify-start gap-[4px] w-full"
        >
          <ButtonToggle
            size="lg"
            type="check"
            checked={isAlwaysUseThisName}
            className="text-pure-white [--color-text-sub-lv3:currentColor] [--color-surface-lv2:rgba(255,255,255,0.20)]"
          />
          <p className="text-[13px] leading-[16px] font-medium text-main-dark-1">
            세번째 인물의 이름은 항상 이걸로 할래요
          </p>
        </button>
        <div className="flex flex-col px-[8px] w-full">
          <Button
            size="large"
            disabled={!thirdPersonaName.trim()}
            className="w-full text-pure-white bg-primary-light font-semibold disabled:bg-[#303030] disabled:text-[#4D4D50] text-[17px]"
            onClick={() => {}}
          >
            {t('done')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SettingThirdPersonaPopup;
